function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.7558,
  cy: 24.9033,
  r: 23.8483,
  fill: "white",
  stroke: "#5B5B5B",
  strokeWidth: 2.11
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6387 17.1367L23.3385 19.9093C24.7542 20.2448 25.7528 21.498 25.7528 22.9393V24.3546M25.7528 24.3546C25.7528 25.2359 25.4961 26.0984 25.0135 26.8389L20.5737 33.6509C19.6568 35.0577 17.6466 35.2322 16.4965 34.0047L11.6387 28.8202M25.7528 24.3546L25.7528 23.3007C25.7528 21.6474 26.8981 20.21 28.5221 19.8251L39.8668 17.1367M25.7528 24.3546C25.7528 25.2359 26.0094 26.0984 26.492 26.8389L30.9318 33.6509C31.8487 35.0577 33.8589 35.2322 35.009 34.0047L39.8668 28.8202M11.672 17.1367L23.4681 19.9093C25.0087 20.3402 26.638 20.3534 28.1856 19.9474L28.6516 19.8251L39.8748 17.1367",
  stroke: "#5B5B5B",
  strokeWidth: 2.10983,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgProvision = function SvgProvision(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProvision, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/provision.214c15c2.svg";
export { ForwardRef as ReactComponent };